/**
 * Utility function to convert CoreUI icon names (camelCase) to PrimeNG icon format
 * 
 * Examples:
 * - cilFile -> pi pi-file
 * - cilLibrary -> pi pi-book
 * - cilFolder -> pi pi-folder
 * - cilFolderOpen -> pi pi-folder-open
 * 
 * @param iconName - The CoreUI icon name in camelCase format
 * @returns The converted icon name in PrimeNG format (pi pi-*)
 */
// export function convertCoreUIIconsToHTMLIcons(iconName: string): string {
//   if (!iconName) {
//     return iconName;
//   }
  
//   // Remove 'cil' prefix and convert to kebab-case
//   let icon = iconName
//     .replace(/^cil/, '') // Remove 'cil' prefix
//     .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
//     .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
//     .toLowerCase();

//   // Map CoreUI icon names to PrimeNG equivalents
//   const iconMap: { [key: string]: string } = {
//     'library': 'book',
//     'pencil': 'pencil',
//     'trash': 'trash',
//     'folder-open': 'folder-open',
//   };

//   // Use mapped name if available, otherwise use the converted name
//   const mappedIcon = iconMap[icon] || icon;

//   return `pi pi-${mappedIcon}`;
// }

 export function convertCoreUIIconsToHTMLIcons(iconName: string): string {
    let icon = iconName;
    icon = iconName.replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
    .toLowerCase();

    return icon;
  }